export default __webpack_public_path__ + "static/media/camp2.be7cb278.png";